// extracted by mini-css-extract-plugin
export default {"generalContacts":"general-contacts_generalContacts__cai5r","header":"general-contacts_header__STY0g","content":"general-contacts_content__Ju0P6"};